import { HULL_IDS, HULLS } from "@frontier/content/definitions";
import { CARGO_STACK_LIMIT } from "@frontier/content/cargo-stacks";
import type { HullDefinition, HullId } from "@frontier/content/definitions";
import { HULL_DISPLAY_ART } from "./hull-art";
import { credits } from "./ui-labels";
import "./hulls.css";

export function nextHullGoal(
  owned: readonly HullId[],
): HullDefinition | undefined {
  return HULL_IDS.filter((id) => !owned.includes(id))
    .map((id) => HULLS[id])
    .sort((left, right) =>
      BigInt(left.price) < BigInt(right.price) ? -1 : 1,
    )[0];
}

interface Props {
  ownedOnly?: boolean;
  selected: HullId;
  previewed: HullId;
  owned: readonly HullId[];
  purchasingAllowed: boolean;
  busy: boolean;
  onPreview: (hullId: HullId) => void;
}

export function HullPicker({
  ownedOnly = false,
  selected,
  previewed,
  owned,
  purchasingAllowed,
  busy,
  onPreview,
}: Props) {
  const hulls = purchasingAllowed && !ownedOnly
    ? HULL_IDS
    : HULL_IDS.filter((id) => owned.includes(id));
  return (
    <section className="hull-picker" aria-label="Корпуса корабля">
      <div className="hull-picker-heading">
        <span>
          АНГАР / {hulls.length}{" "}
          {hulls.length === 1
            ? "КОРПУС"
            : hulls.length < 5
              ? "КОРПУСА"
              : "КОРПУСОВ"}
        </span>
        {hulls.length > 1 && <span>ЛИСТАЙ →</span>}
      </div>
      <div className="hull-cards">
        {hulls.map((id) => {
          const hull = HULLS[id];
          const isOwned = owned.includes(id);
          const installed = id === selected;
          return (
            <button
              key={id}
              data-hull-id={id}
              className={`hull-card ${installed ? "installed" : ""} ${previewed === id ? "previewed" : ""}`}
              aria-label={`Осмотреть корпус «${hull.name}»`}
              aria-pressed={previewed === id}
              aria-describedby={`hull-summary-${id}`}
              disabled={busy}
              onClick={() => onPreview(id)}
            >
              <img src={HULL_DISPLAY_ART[id]} alt="" />
              <strong>{hull.name} · {"I".repeat(hull.tier)}</strong>
              <span className="hull-summary" id={`hull-summary-${id}`}>
                <span className={`hull-ownership ${isOwned ? "owned" : ""}`}>
                  {installed
                    ? "УСТАНОВЛЕН"
                    : isOwned
                      ? "В АНГАРЕ"
                      : `${credits(hull.price)} КР${hull.componentPrice ? ` + ${hull.componentPrice} КОМП.` : ""}`}
                </span>
                <span className="hull-specs">
                  <span>
                    КРП <b>{hull.hp}</b>
                  </span>
                  <span>
                    ЯЧЕЙКИ <b>{hull.equipmentSlots}</b>
                  </span>
                  <span>
                    ТРЮМ{" "}
                    <b>
                      {hull.capacity}×{CARGO_STACK_LIMIT}
                    </b>
                  </span>
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
